export const switchesOptionsData = [
  {
    groupNames: ["Settings", ""],
    columns: {
      Settings: [
        "deviceName",
        "portName",
        'portProfile',
        "speedLabel",
        "portTypeLabel",
        "aggregate",
        "PVID",
        "allowVlan",
        "poe",
        "rstp",
        "lbdState",
        "ddpState",
        "stpGuard",
      ],
    },
  },
  {
    groupNames: [""],
    hideGroupName: true,
    columns: {
      "": [
        "portSchedule",
        "poeSchedule",
        "accessPolicies",
        "mirror",
        "portIsolate",
        "tags",
        "flowControl",
      ],
    },
  },
  {
    groupNames: ["Status"],
    columns: {
      Status: [
        "port",
        "state",
        "modelName",
        "lldp",
        "numberOfIGMPGroup",
        "deviceIp",
      ],
    },
  },
  {
    groupNames: ["Statistic"],
    columns: {
      Statistic: [
        "poePowerUsage",
        "txTraffic",
        "rxTraffic",
        "txMulticast",
        "rxMulticast",
        "txBroadcast",
        "rxBroadcast",
        "txPackets",
        "rxPackets",
        "totalTraffic",
      ],
    },
  },
];

export const apOptionsData = [
  {
    groupNames: ["Settings"],
    columns: {
      Settings: ["deviceName", "PVID", "allowVlan", "tags"],
    },
  },
  {
    groupNames: ["Status"],
    columns: {
      Status: ["portIndex", "state", "portProfile", "modelName", "lldp", "deviceIp"],
    },
  },
  {
    groupNames: ["Statistic"],
    columns: {
      Statistic: [
        "txTraffic",
        "rxTraffic",
        "txMulticast",
        "rxMulticast",
        "txBroadcast",
        "rxBroadcast",
        "txPackets",
        "rxPackets",
        "totalTraffic",
      ],
    },
  },
];

export const defaultPortTypes = {
  access: {
    key: 'access',
    value: 'access',
    label: 'Access'
  },
  trunk: {
    key: 'trunk',
    value: 'trunk',
    label: 'Trunk',
  }
}

export const defaultStateTypes = {
  enable: {
    key: 'enable',
    value: 'enable',
    label: 'Enable'
  },
  disable: {
    key: 'disable',
    value: 'disable',
    label: 'Disable',
  }
}

export const linkSpeedOptions = [
  { id: 0, label: "Auto", value: "auto" },
  { id: 1, label: "40 Gbps Full Duplex", value: "40G_full" },
  { id: 2, label: "25 Gbps Full Duplex", value: "25G_full" },
  { id: 3, label: "10 Gbps Full Duplex", value: "10G_full" },
  { id: 4, label: "5 Gbps Full Duplex", value: "5G_full" },
  { id: 5, label: "2.5 Gbps Full Duplex", value: "2.5G_full" },
  { id: 6, label: "1 Gbps Full Duplex", value: "1G_full" },
  { id: 7, label: "100 Mbps Full Duplex", value: "100M_full" },
  { id: 8, label: "100 Mbps Half Duplex", value: "100M_half" },
];

export const portStaSpeedMap = {
  1: "Auto",
  2: "10 Mbps Full Duplex",
  3: "100 Mbps Full Duplex",
  4: "1 Gbps Full Duplex",
  5: "1 Gbps Full Duplex",
  6: "1 Gbps Full Duplex",
  7: "2.5 Gbps Full Duplex",
  8: "5 Gbps Full Duplex",
  9: "10 Gbps Full Duplex",
  10: "25 Gbps Full Duplex",
  11: "40 Gbps Full Duplex",
  12: "100 Gbps Full Duplex",
};


export const rawSpeedToOptionValue = {
  a: "auto",
  "100m": "100M_full",
  1: "1G_full",
  2.5: "2.5G_full",
  5: "5G_full",
  10: "10G_full",
  25: "25G_full",
  40: "40G_full",
};

export const defaultProfileList = {
  id: "",
  name: "No Profile",
  label: "No Profile",
  portProfile: "",
  deviceCategory: null,
  assignedPort: [],
  portTags: [],
  allowVlan: null,
  PVID: null,
  portType: null,
  portState: true,
  poeState: true,
  ddpState: true,
  lbdState: true,
  speed: null,
  speedS: null,
  speedT: null,
  version: null,
  isDefault: true,
}

export const defaultAlertInfo = {
  open: false,
  severity: "",
  message: "",
};

export const portTypeOptions = [
  { label: "Access", value: "access" },
  { label: "Trunk", value: "trunk" },
];

export const defaultSelectedModal = {
  switches: "All Models",
  switchesSub: ["All devices"],
  accessPoints: "All Models",
  accessPointsSub: ["All devices"],
}